module.exports = __webpack_public_path__ + "img/bp_lp_nakedlogo.75a717b0.png";